import LabelNone from '@/components/label_none';
import AddOrupEnroll from '@/page/enrollPlan/list/addOrupEnroll';
import { Button, message, Popover, Space, Tag } from 'antd';
import { LgButton, LgDrawer, LgPaginationA, LgPopLayer, LgTable } from 'lancoo-web-ui';
import { useEffect, useRef, useState } from 'react';
import './index.scss'
import { FileOutlined, SearchOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import ReportDrawer from '../EnrollErrorDrawer';
import { CommmonGet, CommmonPost } from '@/util/network/api';
import { useSelector } from 'react-redux';
import { selectUserId } from '../../../../../../store/reducers/userInfo';
import { preview } from '@/util/public';
import { downloadFile } from '@/util/util';

const columns: any = [
    {
        title: "发起时间",
        dataIndex: "createTime",
        key: "createTime",
        align: "center",
        width: 100,
        render: (value, record) => {
            return <div title={value} style={{ color: "#999999" }}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "联系电话",
        dataIndex: "contactPhone",
        key: "contactPhone",
        align: "center",
        width: 100,
        render: (value, record) => {
            return <div title={value} style={{}}>
                {value || "--"}
            </div>
        },
    },
    {
      title: '内容描述',
      dataIndex: 'errorDescription',
      key: 'errorDescription',
      width: 150,
      render: (value, record) => {
        return <div title={value} style={{}}>
            {value || "--"}
        </div>
      },
    },
    {
        title: "证明材料",
        dataIndex: "attachments",
        key: "attachments",
        align: "center",
        width: 60,
        render: (_, record) => {
          const fileCount = record.attachments.length;
          if (fileCount === 0) return <span>0份</span>;
  
          const fileListContent = (
            <div style={{ width: 200 }}>
              {record.attachments.map((file, index) => (
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                  <span>{file.originalName}</span>
                  <Space>
                    <Button type="link" size="small" onClick={()=>preview(file)}>预览</Button>
                    <Button type="link" size="small" onClick={()=>downloadFile(file.url, file.originalName)}>下载</Button>
                  </Space>
                </div>
              ))}
            </div>
          );
  
          return (
            <Popover content={fileListContent} title="文件列表" trigger="click">
              <Button type="link" icon={<FileOutlined onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />}>
                {fileCount}份
              </Button>
            </Popover>
          );
        },
    },
    {
      title: '回复状态',
      dataIndex: 'handleStatus',
      key: 'handleStatus',
      width: 60,
      render: (status) => (
        <Tag color={status ===2 ? 'green' : 'orange'}>
          {status===2? "已回复": "未回复"}
        </Tag>
      ),
    },
    {
      title: '回复时间',
      dataIndex: 'handleTime',
      key: 'handleTime',
      width: 100,
    },
    {
      title: '回复内容',
      dataIndex: 'handleResult',
      key: 'handleResult',
      width: 100,
    },
];

function AuditDetail(props: any) {
    const { visible, changeVisible, selectItem } = props;
    const userId = useSelector(selectUserId);

    const [errorList, setErrorList] = useState<any>([]);
    const [total, setTotal] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const pageSize = 10;

    const getErrorList = () => {
        CommmonGet('/applyError/list', {
            planId: selectItem.planId,
            userId,
            pageIndex,
            pageSize
        }).then((res:any) => {
          let data = res.data||{};
            setErrorList(data.pageList||[]);
            setTotal(data.total);
        }).catch(error => {
            
        })
    }

    useEffect(() => {
      if(visible){
        getErrorList();
      }
    }, [visible, pageIndex]);

    return (
      <LgPopLayer
        title={"我的报名信息有误申报记录"}
        isOpen={visible}
        isCoverLayerClickClose={false}
        onShowLayer={(value: boolean) => {
          changeVisible(!value);
          setErrorList([]);
          setPageIndex(1);
          setTotal(0);
        }}
        width={1080}
        height={635}
        needScroll
        className={'error-modal'}
        isShowBottom={false}
      >
         <div className='detail_cls'>
            <div className='detail_title'>
                共{total}条
            </div>
            <LgTable
                columns={columns}
                data={errorList}
                scroll={{ y: 600 }}
                emptyText={<LabelNone tips="暂无申报记录" search={false} />}
            />
            <div className='error-footer'>
              {
                total>pageSize?
                <LgPaginationA
                  total={Math.ceil(total / pageSize)}
                  size="normal"
                  currentPage={pageIndex}
                  onChangePage={setPageIndex}
              />:
              ""
              }
            
            </div>
            
        </div>
      </LgPopLayer>
       
    )
}

export default AuditDetail
